<template>
  <div>
    <!-- Encabezado -->
    <div
      class="header pb-8 pt-6 pt-lg-6 d-flex align-items-center profile-header"
    >
      <b-container fluid>
        <span class="mask" :style="{ background: 'linear-gradient(90deg, #4d545b, #33383e)', opacity: 0.8 }"></span>
        <b-container fluid class="d-flex align-items-center">
          <b-row>
            <b-col lg="7" md="10">
              <h1 class="display-2 text-white">Nuevo Plan</h1>
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </div>

    <!-- Formulario -->
    <b-container fluid class="mt--6">
      <b-card>
        <b-card-body>
          <form @submit.prevent="ingresarPLAN">
 
            <b-row class="form-group">
              <label class="col-md-2 col-form-label form-control-label"
                >ICCID:</label
              >
              <b-col md="10">
                <base-input
                  v-model="datosICCIDplan"
                  placeholder="Ingrese ICCID"
                  required
                />
              </b-col>
            </b-row>
            <b-row class="form-group">
              <label class="col-md-2 col-form-label form-control-label"
                >PRECIO:</label
              >
              <b-col md="10">
                <base-input
                  v-model="datosprecioPlan"
                  type="number"
                  placeholder="Ingrese Precio"
                />
              </b-col>
            </b-row>
            <b-row class="form-group">
              <label class="col-md-2 col-form-label form-control-label"
                >TIPO:</label
              >
              <b-col md="10">
                <base-input>
                  <select
                    class="form-control"
                    v-model="datosanualmensualPlan"
                    required
                  >
                    <option>Mensual</option>
                    <option>Anual</option>
                    <option>Ilimitado</option>
                  </select>
                </base-input>
              </b-col>
            </b-row>
            <b-row class="form-group">
              <label class="col-md-2 col-form-label form-control-label"
                >Cantidad de :</label
              >
              <b-col md="10">
                <base-input
                  v-model="datosdataprometidaPlan"
                  placeholder="Ingrese Data Prometida"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <base-button
                  type="success"
                  @click="ingresarPLAN"
                  :loading="isLoading"
                >
                  {{ isLoading ? "Guardando..." : "Guardar" }}
                </base-button>
                <base-button type="warning" @click="$router.push('/Plan')"
                  >Cancelar</base-button
                >
              </b-col>
            </b-row>
          </form>
        </b-card-body>
      </b-card>
    </b-container>
    <token-expired-modal :show="showTokenExpiredModal"> </token-expired-modal>
  </div>
</template>

<script>
import Card from "../components/Cards/Card.vue";
import BaseButton from "../components/BaseButton.vue";
import BaseInput from "../components/Inputs/BaseInput.vue";
import axios from "axios";
import TokenExpiredModal from '../components/TokenExpiredModal.vue';

export default {
  components: {
    Card,
    BaseButton,
    BaseInput,
    TokenExpiredModal,
  },
  data() {
    return {
      datosidPlan: "",
      datosICCIDplan: "",
      datosprecioPlan: "",
      datosanualmensualPlan: "Mensual",
      datosdataprometidaPlan: "",
      showTokenExpiredModal: false,
      isLoading: false,
    };
  },
  methods: {
    async ingresarPLAN() {
      this.isLoading = true;
      try {
        const token = localStorage.getItem("token");
        if (!token
          
        ) {
          this.mostrarError("Token no presente. Usuario no autenticado.");
          return;
        }
        // Validar si los campos obligatorios están vacíos
        if (
          !this.datosICCIDplan ||
          !this.datosprecioPlan ||
          !this.datosanualmensualPlan ||
          !this.datosdataprometidaPlan
        ) {
          this.mostrarError("Por favor, complete todos los campos.");
          return;
        }
        const datos = {
          ID: this.datosidPlan,
          ICCID: this.datosICCIDplan,
          PRECIO: this.datosprecioPlan,
          ANUALMENSUAL: this.datosanualmensualPlan,
          DATAPROMETIDA: this.datosdataprometidaPlan,
        };

        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/insertarDatosPLAN`,
          datos,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data.success) {
          this.mostrarExito("Datos Insertados Correctamente");
          this.$router.push("/Plan");
        } else {
          this.mostrarError(response.data.message || "Error al Insertar Datos");
        }
      } catch (error) {
        this.mostrarError("Error al Insertar Datos");
      } finally {
        this.isLoading = false;
      }
    },
    mostrarError(mensaje) {
      this.$notify({
        type: "danger",
        title: "Error al insertar datos",
        text: mensaje,
      });
    },

    mostrarExito(mensaje) {
      this.$notify({
        type: "success",
        title: "Datos insertados correctamente",
        text: mensaje,
      });
    },
    handleTokenExpired() {
      this.showTokenExpiredModal = true;
      setTimeout(() => {
        this.$router.push("/login");
      }, 3000);
    },
  },
};
</script>
